import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { RBaseButton } from './RBaseButton';

interface RCardHeaderButtonProps {
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
    children?: React.ReactNode;
}

export function RCardHeaderButton({ icon, label, onClick, children }: RCardHeaderButtonProps) {
    return (
        <Button onClick={onClick}>
            {icon}
            {label}
            {children}
        </Button>
    );
}

const Button = styled(RBaseButton)({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 20,
    fontSize: 14,
    color: Colors.mediumGrey,
    padding: '6px 16px',
    whiteSpace: 'nowrap',
    '&:hover': {
        color: Colors.darkNavy,
        backgroundColor: Colors.faintGrey,
        borderColor: Colors.faintGrey,
    },
});
